// Layout.js

import React from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';

const Layout = ({ children }) => {
  const location = useLocation();
  const hideFooterOnPaths = ['/contact', '/']; // Add paths where you want to hide the footer

  const shouldHideFooter = hideFooterOnPaths.includes(location.pathname);

  return (
    <div className="layout">
      {children}
      {!shouldHideFooter && <Footer />}
    </div>
  );
};

export default Layout;
